import PropTypes from 'prop-types';

import * as Styled from './Logo.style';

export function Logo({ height = 48, src = '', alt = 'logo-lottie' }) {
  if (src && src.includes('json')) {
    return <Styled.LogoLottieRoot alt={alt} height={height} src={src} />;
  }
  return <Styled.LogoRoot alt={alt} height={height} src={src} />;
}

Logo.propTypes = {
  height: PropTypes.number,
  src: PropTypes.string,
  alt: PropTypes.string
};

export default Logo;
